module.exports = __webpack_public_path__ + "img/terminalstamplogo.ff908876.jpg";